export const STAINLESS_FASHION_LABEL = 'Steel Jewellery';
export const BRASS_CZ_COLOUR_STONE_IMITATION = 'Brass-CZ-Colour Stone (Imitation)';
export const STAINLESS_FASHION_DISPLAY_LABEL = 'Steel-Fashion';
export const BRASS_IMITATION_DISPLAY_LABEL = 'Brass-Imitation';
export const LEGACY_PLATINUM_GOLD_STUDDED = 'Platinum-Gold-Studded (LGD/Natural)';
export const BROOCH_JEWELRY_TYPE = 'Brooch';

const SILVER_PLAIN = 'Silver-Plain';
const SILVER_CZ_COLOUR_STONES = 'Silver-CZ-Colour Stones';
const SILVER_LGD = 'Silver-LGD';
const SILVER_NATURAL_DIAMONDS = 'Silver-Natural Diamonds';
const GOLD_PLAIN = 'Gold-Plain';
const GOLD_CZ_COLOUR_STONES = 'Gold-CZ-Colour Stones';
const GOLD_LGD = 'Gold-LGD';
const GOLD_NATURAL_DIAMONDS = 'Gold-Natural Diamonds';
const PLATINUM_PLAIN = 'Platinum-Plain';
const PLATINUM_LGD = 'Platinum-LGD';
const PLATINUM_NATURAL_DIAMONDS = 'Platinum-Natural Diamonds';
const PLATINUM_GOLD_PLAIN = 'Platinum-Gold-Plain';
const PLATINUM_GOLD_LGD = 'Platinum-Gold-LGD';
const PLATINUM_GOLD_NATURAL_DIAMONDS = 'Platinum-Gold-Natural Diamonds';

export const JEWELRY_TYPE_COLUMNS = [
  [
    'Ladies Ring',
    'Ladies Bracelet',
    'Pendents',
    'Earrings',
    'Pendent sets',
  ],
  [
    'Round bangles',
    'Oval bangle',
    'Mangalsutra',
    'Anklets',
    'Necklace sets',
  ],
  [
    'Choker',
    'Gents rings',
    'Gents bracelet',
    'Plain chains',
    BROOCH_JEWELRY_TYPE,
  ],
];

const LEGACY_EXTRA_JEWELRY_TYPES = [
  '(EARRING+PENDANT)',
];

const JEWELRY_TYPE_ORDER_ALIASES = [
  ['Ladies Ring', 'LADIES RING', 'LADIES RINGS'],
  ['Ladies Bracelet', 'LADIES BRACELET', 'LADIES BRACELETS'],
  ['Pendents', 'PENDENT', 'PENDENTS', 'PENDANT', 'PENDANTS'],
  ['Earrings', 'EARRING', 'EARRINGS'],
  ['Pendent sets', 'PENDENT SET', 'PENDENT SETS', 'PENDANT SET', 'PENDANT SETS', 'PENDANT SET (EARRING+PENDANT)'],
  ['Round bangles', 'ROUND BANGLE', 'ROUND BANGLES'],
  ['Oval bangle', 'OVAL BANGLE', 'OVAL BANGLES'],
  ['Mangalsutra', 'MANGALSUTRA'],
  ['Anklets', 'ANKLET', 'ANKLETS'],
  ['Necklace sets', 'NECKLACE SET', 'NECKLACE SETS'],
  ['Choker', 'CHOKER'],
  ['Gents rings', 'GENTS RING', 'GENTS RINGS'],
  ['Gents bracelet', 'GENTS BRACELET', 'GENTS BRACELETS'],
  ['Plain chains', 'PLAIN CHAIN', 'PLAIN CHAINS'],
  [BROOCH_JEWELRY_TYPE, 'BROOCH', 'BROOCHES'],
];

export const DEFAULT_JEWELRY_TYPES = [
  ...JEWELRY_TYPE_COLUMNS.flat(),
  ...LEGACY_EXTRA_JEWELRY_TYPES,
];

const DEFAULT_JEWELRY_TYPE_COLUMNS = JEWELRY_TYPE_COLUMNS.map((column) => [...column]);

const normalizeJewelryTypeToken = (value = '') =>
  String(value || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toUpperCase();

const findMatchingJewelryTypeIndex = (items, aliases, usedIndexes) => {
  const aliasTokens = aliases.map(normalizeJewelryTypeToken);

  return items.findIndex((item, index) =>
    !usedIndexes.has(index) && aliasTokens.includes(normalizeJewelryTypeToken(item))
  );
};

const getJewelryTypeAliasTokens = (defaultType) => {
  const defaultToken = normalizeJewelryTypeToken(defaultType);
  const aliases = JEWELRY_TYPE_ORDER_ALIASES.find((aliasGroup) =>
    normalizeJewelryTypeToken(aliasGroup[0]) === defaultToken
  ) || [defaultType];

  return aliases.map(normalizeJewelryTypeToken);
};

export const orderJewelryTypes = (types = DEFAULT_JEWELRY_TYPES) => {
  const sourceTypes = (Array.isArray(types) ? types : [])
    .map((type) => String(type || '').trim())
    .filter(Boolean);
  const usedIndexes = new Set();
  const seenTokens = new Set();
  const orderedTypes = [];

  JEWELRY_TYPE_ORDER_ALIASES.forEach((aliases) => {
    const matchedIndex = findMatchingJewelryTypeIndex(sourceTypes, aliases, usedIndexes);

    if (matchedIndex === -1) {
      return;
    }

    const canonicalType = aliases[0];

    usedIndexes.add(matchedIndex);
    aliases.forEach((alias) => seenTokens.add(normalizeJewelryTypeToken(alias)));

    orderedTypes.push(canonicalType);
  });

  sourceTypes.forEach((type, index) => {
    const typeToken = normalizeJewelryTypeToken(type);

    if (!usedIndexes.has(index) && !seenTokens.has(typeToken)) {
      seenTokens.add(typeToken);
      orderedTypes.push(type);
    }
  });

  return orderedTypes;
};

export const arrangeJewelryTypesForThreeColumnGrid = (types = DEFAULT_JEWELRY_TYPES) => {
  const orderedTypes = orderJewelryTypes(types);
  const consumedTokens = new Set();
  const columns = DEFAULT_JEWELRY_TYPE_COLUMNS.map((column) =>
    column
      .map((defaultType) => {
        const defaultTypeAliasTokens = getJewelryTypeAliasTokens(defaultType);
        const matchedType = orderedTypes.find((type) => {
          const typeToken = normalizeJewelryTypeToken(type);
          return !consumedTokens.has(typeToken)
            && defaultTypeAliasTokens.includes(typeToken);
        });

        if (matchedType) {
          consumedTokens.add(normalizeJewelryTypeToken(matchedType));
        }

        return matchedType || null;
      })
      .filter(Boolean)
  );
  const arrangedTypes = [];
  const maxColumnLength = Math.max(...columns.map((column) => column.length));

  for (let rowIndex = 0; rowIndex < maxColumnLength; rowIndex += 1) {
    columns.forEach((column) => {
      if (column[rowIndex]) {
        arrangedTypes.push(column[rowIndex]);
      }
    });
  }

  orderedTypes.forEach((type) => {
    if (!consumedTokens.has(normalizeJewelryTypeToken(type))) {
      arrangedTypes.push(type);
    }
  });

  return arrangedTypes;
};

export const LEGACY_JEWELRY_TYPES = [
  'LADIES RING',
  'GENTS RING',
  'EARRINGS',
  'PENDANTS',
  'PENDANT SET',
  '(EARRING+PENDANT)',
  'ROUND BANGLES',
  'OVAL BANGLES',
  'MANGALSUTRA',
  'GENTS BRACELETS',
  'LADIES BRACELETS',
  'NECKLACE SET',
  'CHOKER',
  'PLAIN CHAINS',
  'ANKLETS',
  'BROOCH',
];

export const DEFAULT_PARENT_DIRECT_JEWELRY_TYPES = [BROOCH_JEWELRY_TYPE];
const EMPTY_PARENT_DIRECT_JEWELRY_TYPES = [];

export const DEFAULT_JEWELRY_MENU_GROUPS = [
  {
    id: 'stainless-fashion',
    label: STAINLESS_FASHION_DISPLAY_LABEL,
    behavior: 'direct-material',
    materialValue: STAINLESS_FASHION_LABEL,
    directProductTypes: EMPTY_PARENT_DIRECT_JEWELRY_TYPES,
  },
  {
    id: 'brass-cz-colour-stone-imitation',
    label: BRASS_IMITATION_DISPLAY_LABEL,
    behavior: 'product-types',
    materialValue: BRASS_CZ_COLOUR_STONE_IMITATION,
    directProductTypes: DEFAULT_PARENT_DIRECT_JEWELRY_TYPES,
  },
  {
    id: 'silver',
    label: 'Silver',
    behavior: 'nested-materials',
    directProductTypes: EMPTY_PARENT_DIRECT_JEWELRY_TYPES,
    children: [
      { id: 'silver-plain', label: SILVER_PLAIN, materialValue: SILVER_PLAIN },
      { id: 'silver-cz-colour-stones', label: SILVER_CZ_COLOUR_STONES, materialValue: SILVER_CZ_COLOUR_STONES },
      { id: 'silver-lgd', label: SILVER_LGD, materialValue: SILVER_LGD },
      { id: 'silver-natural-diamonds', label: SILVER_NATURAL_DIAMONDS, materialValue: SILVER_NATURAL_DIAMONDS },
    ],
  },
  {
    id: 'gold',
    label: 'Gold',
    behavior: 'nested-materials',
    directProductTypes: EMPTY_PARENT_DIRECT_JEWELRY_TYPES,
    children: [
      { id: 'gold-plain', label: GOLD_PLAIN, materialValue: GOLD_PLAIN },
      { id: 'gold-cz-colour-stones', label: GOLD_CZ_COLOUR_STONES, materialValue: GOLD_CZ_COLOUR_STONES },
      { id: 'gold-lgd', label: GOLD_LGD, materialValue: GOLD_LGD },
      { id: 'gold-natural-diamonds', label: GOLD_NATURAL_DIAMONDS, materialValue: GOLD_NATURAL_DIAMONDS },
    ],
  },
  {
    id: 'platinum',
    label: 'Platinum',
    behavior: 'nested-materials',
    directProductTypes: EMPTY_PARENT_DIRECT_JEWELRY_TYPES,
    children: [
      { id: 'platinum-plain', label: PLATINUM_PLAIN, materialValue: PLATINUM_PLAIN },
      { id: 'platinum-lgd', label: PLATINUM_LGD, materialValue: PLATINUM_LGD },
      { id: 'platinum-natural-diamonds', label: PLATINUM_NATURAL_DIAMONDS, materialValue: PLATINUM_NATURAL_DIAMONDS },
    ],
  },
  {
    id: 'platinum-gold',
    label: 'Platinum Gold',
    behavior: 'nested-materials',
    directProductTypes: EMPTY_PARENT_DIRECT_JEWELRY_TYPES,
    children: [
      { id: 'platinum-gold-plain', label: PLATINUM_GOLD_PLAIN, materialValue: PLATINUM_GOLD_PLAIN },
      { id: 'platinum-gold-lgd', label: PLATINUM_GOLD_LGD, materialValue: PLATINUM_GOLD_LGD },
      {
        id: 'platinum-gold-natural-diamonds',
        label: PLATINUM_GOLD_NATURAL_DIAMONDS,
        materialValue: PLATINUM_GOLD_NATURAL_DIAMONDS,
      },
    ],
  },
];

const DISPLAY_ACRONYMS = new Set(['CZ', 'LGD']);

export const normalizeCatalogToken = (value = '') =>
  String(value || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toUpperCase();

const MATERIAL_ALIASES = {
  [BRASS_CZ_COLOUR_STONE_IMITATION]: [
    BRASS_CZ_COLOUR_STONE_IMITATION,
    BRASS_IMITATION_DISPLAY_LABEL,
    'BRASS-CZ-COLOR STONE',
    'BRASS-CZ-COLOUR STONE',
    'BRASS-CZ-COLOR STONE (IMITATION)',
    'BRASS-CZ-COLOUR STONE (IMITATION)',
  ],
  [STAINLESS_FASHION_LABEL]: [
    STAINLESS_FASHION_LABEL,
    STAINLESS_FASHION_DISPLAY_LABEL,
    'STEEL JEWELLERY',
    'STEEL JEWELRY',
    'STAINLESS FASHION',
    'STAINLESS STEEL',
  ],
  [SILVER_PLAIN]: [SILVER_PLAIN, 'SILVER-PLAIN'],
  [SILVER_CZ_COLOUR_STONES]: [
    SILVER_CZ_COLOUR_STONES,
    'SILVER-CZ-COLOUR STONES',
    'SILVER-CZ-COLOUR STONE',
    'SILVER-CZ-COLOR STONES',
    'SILVER-CZ-COLOR STONE',
    'SILVER- CZ-COLOR STONE',
  ],
  [SILVER_LGD]: [SILVER_LGD, 'SILVER-LGD', 'SILVER-CVD (LGD)', 'SILVER-CVD (LAB GROWN DIA.)'],
  [SILVER_NATURAL_DIAMONDS]: [SILVER_NATURAL_DIAMONDS, 'SILVER-NATURAL DIAMONDS', 'SILVER-NATURAL DIAMOND'],
  [GOLD_PLAIN]: [GOLD_PLAIN, 'GOLD-PLAIN'],
  [GOLD_CZ_COLOUR_STONES]: [
    GOLD_CZ_COLOUR_STONES,
    'GOLD-CZ-COLOUR STONES',
    'GOLD-CZ-COLOUR STONE',
    'GOLD-CZ-COLOR STONES',
    'GOLD-CZ-COLOR STONE',
  ],
  [GOLD_LGD]: [
    GOLD_LGD,
    'GOLD-LGD',
    'GOLD-CVD (LGD)',
    'GOLD- CVD (LGD)',
    'GOLD- CVD(LGD)',
    'GOLD-CVD (LAB GROWN DIA.)',
    'GOLD- CVD(LAB GROWN DIA.)',
  ],
  [GOLD_NATURAL_DIAMONDS]: [GOLD_NATURAL_DIAMONDS, 'GOLD-NATURAL DIAMONDS', 'GOLD-NATURAL DIAMOND'],
  [PLATINUM_PLAIN]: [PLATINUM_PLAIN, 'PLATINUM-PLAIN'],
  [PLATINUM_LGD]: [PLATINUM_LGD, 'PLATINUM-LGD', 'PLATINUM-CVD (LGD)', 'PLATINUM-CVD (LAB GROWN DIA.)'],
  [PLATINUM_NATURAL_DIAMONDS]: [PLATINUM_NATURAL_DIAMONDS, 'PLATINUM-NATURAL DIAMONDS', 'PLATINUM-NATURAL DIAMOND'],
  [PLATINUM_GOLD_PLAIN]: [PLATINUM_GOLD_PLAIN, 'PLATINUM-GOLD-PLAIN'],
  [PLATINUM_GOLD_LGD]: [PLATINUM_GOLD_LGD, 'PLATINUM-GOLD-LGD'],
  [PLATINUM_GOLD_NATURAL_DIAMONDS]: [
    PLATINUM_GOLD_NATURAL_DIAMONDS,
    'PLATINUM-GOLD-NATURAL DIAMONDS',
    'PLATINUM-GOLD-NATURAL DIAMOND',
  ],
  [LEGACY_PLATINUM_GOLD_STUDDED]: [
    LEGACY_PLATINUM_GOLD_STUDDED,
    'PLATINUM-GOLD-STUDDED (LGD/NATURAL)',
    'PLATINUM-GOLD-STUDDED (LGD/NAT.)',
  ],
};

const aliasLookup = Object.entries(MATERIAL_ALIASES).reduce((lookup, [canonicalValue, aliases]) => {
  aliases.forEach((alias) => {
    lookup.set(normalizeCatalogToken(alias), canonicalValue);
  });
  return lookup;
}, new Map());

const cloneGroups = (groups = DEFAULT_JEWELRY_MENU_GROUPS) =>
  groups.map((group) => ({
    ...group,
    isHidden: Boolean(group.isHidden),
    hiddenDirectProductTypes: Array.isArray(group.hiddenDirectProductTypes) ? [...group.hiddenDirectProductTypes] : [],
    directProductTypes: Array.isArray(group.directProductTypes) ? [...group.directProductTypes] : [],
    children: Array.isArray(group.children) ? group.children.map((child) => ({ ...child })) : [],
  }));

const createChildId = (materialValue = '') =>
  normalizeCatalogToken(materialValue)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'custom-material';

export const normalizeJewelryMaterialValue = (value = '') => {
  const trimmedValue = String(value || '').trim().replace(/\s+/g, ' ');

  if (!trimmedValue) {
    return '';
  }

  return aliasLookup.get(normalizeCatalogToken(trimmedValue)) || trimmedValue;
};

export const formatJewelryMaterialDisplayLabel = (value = '') => {
  const normalizedValue = normalizeJewelryMaterialValue(value);

  if (normalizedValue === STAINLESS_FASHION_LABEL) {
    return STAINLESS_FASHION_DISPLAY_LABEL;
  }

  if (normalizedValue === BRASS_CZ_COLOUR_STONE_IMITATION) {
    return BRASS_IMITATION_DISPLAY_LABEL;
  }

  return normalizedValue;
};

const normalizeChild = (child = {}, fallbackChild = null) => {
  const materialValue = fallbackChild?.materialValue
    || normalizeJewelryMaterialValue(child.materialValue || child.value || child.label || '');
  const label = String(child.label || fallbackChild?.label || materialValue || '').trim();

  if (!materialValue || !label) {
    return null;
  }

  return {
    id: String(child.id || fallbackChild?.id || createChildId(materialValue)).trim(),
    label,
    materialValue,
    isHidden: Boolean(child.isHidden ?? fallbackChild?.isHidden),
  };
};

export const inferJewelryMenuGroupIdFromMaterial = (materialValue = '') => {
  const normalizedMaterial = normalizeCatalogToken(materialValue);

  if (!normalizedMaterial) {
    return '';
  }

  if (normalizedMaterial.includes('PLATINUM-GOLD') || normalizedMaterial.includes('PLATINUM GOLD')) {
    return 'platinum-gold';
  }

  if (normalizedMaterial.startsWith('PLATINUM')) {
    return 'platinum';
  }

  if (normalizedMaterial.startsWith('GOLD')) {
    return 'gold';
  }

  if (normalizedMaterial.startsWith('SILVER')) {
    return 'silver';
  }

  if (normalizedMaterial.startsWith('BRASS')) {
    return 'brass-cz-colour-stone-imitation';
  }

  if (normalizedMaterial.includes('STAINLESS') || normalizedMaterial.includes('STEEL')) {
    return 'stainless-fashion';
  }

  return '';
};

export const findJewelryMenuGroupById = (groupId = '', groups = DEFAULT_JEWELRY_MENU_GROUPS) =>
  groups.find((group) => group.id === groupId) || null;

export const findJewelryMenuGroupByMaterial = (materialValue = '', groups = DEFAULT_JEWELRY_MENU_GROUPS) => {
  const normalizedMaterial = normalizeCatalogToken(normalizeJewelryMaterialValue(materialValue));

  if (!normalizedMaterial) {
    return null;
  }

  const exactGroup = groups.find((group) => {
    if (group.materialValue && normalizeCatalogToken(group.materialValue) === normalizedMaterial) {
      return true;
    }

    return Array.isArray(group.children)
      && group.children.some((child) => normalizeCatalogToken(child.materialValue) === normalizedMaterial);
  });

  if (exactGroup) {
    return exactGroup;
  }

  return findJewelryMenuGroupById(inferJewelryMenuGroupIdFromMaterial(materialValue), groups);
};

export const normalizeJewelryMenuGroups = (groups = []) => {
  const incomingGroups = Array.isArray(groups) ? groups : [];

  return cloneGroups().map((defaultGroup) => {
    const matchedSourceGroup = incomingGroups.find((group) => {
      const keys = [group?.id, group?.label, group?.materialValue].filter(Boolean);
      return keys.some((key) => {
        const normalizedKey = normalizeCatalogToken(key);
        return normalizedKey === normalizeCatalogToken(defaultGroup.id)
          || normalizedKey === normalizeCatalogToken(defaultGroup.label)
          || normalizedKey === normalizeCatalogToken(defaultGroup.materialValue || '');
      });
    });

    if (defaultGroup.behavior !== 'nested-materials') {
      const resolvedLabel = formatJewelryMaterialDisplayLabel(matchedSourceGroup?.label || defaultGroup.label);

      return {
        ...defaultGroup,
        isHidden: Boolean(matchedSourceGroup?.isHidden ?? defaultGroup.isHidden),
        hiddenDirectProductTypes: Array.isArray(matchedSourceGroup?.hiddenDirectProductTypes)
          ? matchedSourceGroup.hiddenDirectProductTypes.map((item) => String(item || '').trim()).filter(Boolean)
          : defaultGroup.hiddenDirectProductTypes || [],
        directProductTypes: Array.isArray(matchedSourceGroup?.directProductTypes)
          ? matchedSourceGroup.directProductTypes.map((item) => String(item || '').trim()).filter(Boolean)
          : defaultGroup.directProductTypes || [],
        label: String(resolvedLabel || defaultGroup.label).trim() || defaultGroup.label,
        materialValue: defaultGroup.materialValue,
        children: [],
      };
    }

    const sourceChildren = Array.isArray(matchedSourceGroup?.children) ? matchedSourceGroup.children : [];
    const defaultChildTokens = new Set(defaultGroup.children.map((child) => normalizeCatalogToken(child.materialValue)));

    const normalizedChildren = defaultGroup.children
      .map((defaultChild) => {
        const matchedSourceChild = sourceChildren.find((child) =>
          normalizeCatalogToken(child?.materialValue || child?.value || child?.label || '')
          === normalizeCatalogToken(defaultChild.materialValue)
        );

        return normalizeChild(matchedSourceChild || defaultChild, defaultChild);
      })
      .filter(Boolean);

    const extraChildren = sourceChildren
      .map((child) => normalizeChild(child))
      .filter((child) => child && !defaultChildTokens.has(normalizeCatalogToken(child.materialValue)));

    return {
      ...defaultGroup,
      isHidden: Boolean(matchedSourceGroup?.isHidden ?? defaultGroup.isHidden),
      hiddenDirectProductTypes: Array.isArray(matchedSourceGroup?.hiddenDirectProductTypes)
        ? matchedSourceGroup.hiddenDirectProductTypes.map((item) => String(item || '').trim()).filter(Boolean)
        : defaultGroup.hiddenDirectProductTypes || [],
      directProductTypes: Array.isArray(matchedSourceGroup?.directProductTypes)
        ? matchedSourceGroup.directProductTypes.map((item) => String(item || '').trim()).filter(Boolean)
        : defaultGroup.directProductTypes || [],
      label: String(matchedSourceGroup?.label || defaultGroup.label).trim() || defaultGroup.label,
      children: [...normalizedChildren, ...extraChildren],
    };
  });
};

export const flattenJewelryMenuMaterials = (groups = DEFAULT_JEWELRY_MENU_GROUPS) =>
  normalizeJewelryMenuGroups(groups).reduce((materials, group) => {
    if (group.behavior === 'nested-materials') {
      return [...materials, ...group.children.map((child) => child.materialValue)];
    }

    return [...materials, group.materialValue];
  }, []);

export const DEFAULT_JEWELRY_METALS = flattenJewelryMenuMaterials(DEFAULT_JEWELRY_MENU_GROUPS);

export const buildJewelryMenuGroupsFromMetals = (values = []) => {
  const baseGroups = cloneGroups();

  (Array.isArray(values) ? values : [])
    .map((value) => normalizeJewelryMaterialValue(value))
    .filter(Boolean)
    .forEach((materialValue) => {
      const matchedGroup = findJewelryMenuGroupByMaterial(materialValue, baseGroups);

      if (!matchedGroup || matchedGroup.behavior !== 'nested-materials') {
        return;
      }

      const materialToken = normalizeCatalogToken(materialValue);
      const alreadyExists = matchedGroup.children.some(
        (child) => normalizeCatalogToken(child.materialValue) === materialToken
      );

      if (alreadyExists) {
        return;
      }

      matchedGroup.children.push({
        id: createChildId(materialValue),
        label: materialValue,
        materialValue,
      });
    });

  return normalizeJewelryMenuGroups(baseGroups);
};

export const isDirectListingJewelryMetal = (value = '') =>
  normalizeCatalogToken(normalizeJewelryMaterialValue(value)) === normalizeCatalogToken(STAINLESS_FASHION_LABEL);

export const formatCategoryDisplayName = (value = '') =>
  String(formatJewelryMaterialDisplayLabel(value) || '')
    .trim()
    .replace(/[A-Za-z]+/g, (word) => {
      const normalizedWord = word.toUpperCase();

      if (DISPLAY_ACRONYMS.has(normalizedWord)) {
        return normalizedWord;
      }

      return normalizedWord.charAt(0) + normalizedWord.slice(1).toLowerCase();
    });
